import type { BaseSlideProps } from './SlideLayout.types';

interface TitleSlideContent {
  subtitle?: string;
  visual?: string;
}

export function TitleSlide({ title, content, accentColor }: BaseSlideProps) {
  const { subtitle } = content as TitleSlideContent;

  return (
    <div
      className="slide-content flex flex-col items-center justify-center text-center min-h-[600px]"
      style={{ '--color-accent': accentColor } as React.CSSProperties}
    >
      <div className="max-w-3xl mx-auto">
        <h1 className="text-6xl font-serif font-bold mb-6 accent-text animate-fade-in-up">
          {title}
        </h1>

        {subtitle && (
          <p className="text-2xl text-slate-600 dark:text-slate-400 mb-8 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            {subtitle}
          </p>
        )}

        {/* Visual asset placeholder — hidden until assets are added */}
      </div>
    </div>
  );
}
